export default __webpack_public_path__ + "static/media/IMG_1188.b3ceccb7.jpg";